import ShelfController from '../../core/shelf.controller';
import Inherit from '../../core/inherit';
import { message } from 'antd';
import { TOTAL_QUESTIONS } from './pollQuestions';
import PollsDelegate from './polls.delegate';
import { applyPollFilters } from './elements';

class PollsController extends Inherit(ShelfController, PollsDelegate) {
    async initialize() {
        let polls = [];

        if (!this.isAuthenticated) this.navigateLogin();

        const pollInfo = await this.data.fetchPolls();
        polls = this.preparePollsData(await this.withClients(Array.isArray(pollInfo) ? pollInfo.reverse() : []));

        this.setState({ polls, loading: false });
    }

    async deletePoll(id) {
        try {
            await this.data.deletePoll(id);
            this.setState((prev) => ({ polls: prev.polls.filter((p) => p._id !== id) }));
            message.success('Encuesta eliminada correctamente');
        } catch (err) {
            message.error(err?.response?.data?.message || err?.message || 'No se pudo eliminar la encuesta');
        }
    }

    /**
     * APIs that answer polls with the client as an id (not populated) get it resolved from the
     * client list, so the client / channel columns and filters keep working.
     */
    async withClients(polls) {
        if (!polls.some((poll) => poll?.client && typeof poll.client !== 'object')) return polls;
        try {
            const clients = await this.data.fetchClients();
            const list = Array.isArray(clients) ? clients : clients?.clients || clients?.data || [];
            const byId = new Map(list.map((client) => [String(client?._id), client]));
            return polls.map((poll) => (poll?.client && typeof poll.client !== 'object' ? { ...poll, client: byId.get(String(poll.client)) || null } : poll));
        } catch {
            return polls;
        }
    }

    /** Polls matching the active filters (feeds both the KPIs and the table). */
    getFilteredPolls() {
        const { polls, filters } = this.state;
        return applyPollFilters(polls, filters);
    }

    preparePollsData(polls) {
        const pollsData = polls.map((poll, i) => {
            const totalTrue = poll?.values?.filter((value) => value?.answer === true).length ?? 0;
            const regions = Array.isArray(poll?.regions) ? poll.regions : [];

            return {
                key: poll?._id ?? i,
                ...poll,
                // Flattened, filter-friendly fields derived from the populated refs
                asesor: poll?.user?.name ?? '',
                rol: poll?.user?.userType ?? '',
                canal: poll?.client?.channel ?? '',
                cliente: poll?.client?.name ?? '',
                regions,
                answers: `${totalTrue} / ${TOTAL_QUESTIONS}`,
                percentage: `${((totalTrue / TOTAL_QUESTIONS) * 100).toFixed(2)}%`,
            };
        });

        return pollsData;
    }
}

export default PollsController;
